import type { GetDashboardStatistics200Statistics } from './getDashboardStatistics200Statistics';

export type GetDashboardStatistics200 = {
  message?: string;
  statistics?: GetDashboardStatistics200Statistics;
  success: boolean;
};
